<template>
  <div>
    <div v-for="(image, index) in getContent" :key="index" class="imgWrapper">
      <!-- <div v-if="isLoading">
        <v-progress-circular indeterminate :size="14" :width="2"></v-progress-circular>
      </div> -->
      <img :src="getImgContent(image, 'url')" class="image" @click="imageClick(image)" alt="" @load="imgLoaded" />
      <br />
      <span class="txt" v-if="getImgContent(image, 'comment')" v-html="getImgContent(image, 'comment')"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageList',
  props: {
    content: String,
    headerStyle: Object
  },
  data() {
    return {
      isLoading: true
    };
  },
  computed: {
    getContent() {
      try {
        // 묶음 이미지 발송 2차 개발 때 포맷 통일에 대한 논의가 추가로 이루어져야 할 것 같습니다.
        const parsed = JSON.parse(this.content);
        if (Array.isArray(parsed)) {
          return parsed;
        } else {
          return [parsed];
        }
      } catch (error) {
        return [
          {
            url: '',
            comment: '이미지 파싱 오류'
          }
        ];
      }
    }
  },
  methods: {
    getImgContent(content, type) {
      return content[type];
    },
    imageClick(content) {
      this.$mitt.emit('windowOpen', {
        url: content.url,
        target: 'imageWindow',
        features: 'toolbar=no,menubar=no,resizeable=1,width=800,height=800'
      });
    },
    imgLoaded() {
      this.isLoading = false;
      this.$emit('imgLoaded');
    }
  }
};
</script>

<style scoped>
.image-max {
  max-width: 240px;
  cursor: zoom-in;
}
.imgLoadingProgress {
  min-width: 90px;
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
